'use client'

import { ClerkProvider, useAuth } from '@clerk/nextjs'
import { ConvexProviderWithClerk } from 'convex/react-clerk'
import { ConvexReactClient } from 'convex/react'
import { UserInitializer } from './UserInitializer'
import { AnalyticsInit } from './AnalyticsInit'

// Only initialize Convex if URL is provided
const convexUrl = process.env.NEXT_PUBLIC_CONVEX_URL
const convex = convexUrl ? new ConvexReactClient(convexUrl) : null

export function ConvexClientProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const clerkProps = {
    dynamic: true as const,
    signInUrl: '/sign-in',
    signUpUrl: '/sign-up',
    signInFallbackRedirectUrl: '/dashboard',
    signUpFallbackRedirectUrl: '/dashboard',
  }

  // If Convex isn't set up, just use ClerkProvider
  if (!convex) {
    return (
      <ClerkProvider {...clerkProps}>
        {children}
      </ClerkProvider>
    )
  }

  return (
    <ClerkProvider {...clerkProps}>
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <UserInitializer />
        <AnalyticsInit />
        {children}
      </ConvexProviderWithClerk>
    </ClerkProvider>
  )
}
